declare const MYTC_MAINTENANCE_MODE: boolean;

/** True only for the main production web build. Staging and production share that artifact. */
export const maintenanceMode = MYTC_MAINTENANCE_MODE;
